import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import WaterwayItemTypeView from '../ItemsView/WaterwayItemTypeView';
import ItemTypeView from '../ItemsView/ItemTypeView';
import ItemTypeListView from '../ItemsView/ItemTypeListView';
import LargeFarmView from './LargeFarmView';
import Documents from '../Uploads/Documents';
import ActionsToConsider from '../FarmApt/ActionsToConsider';
import WholeFarmActionView from './WholeFarmActionView';
import HistoricalActions from './HistoricalActions';
import {  FaSlash} from 'react-icons/fa';
const NonMapView = ({ handleHideChildrenCheck, hideChildren, toggleChildItemState, handleChildItemToggle,handleSectionCommentChange,itemModel, handleClearSelection, toggleItemTypeListState, toggleItemTypeState, toggleItemState,
    handleItemClick, handleItemEditPopup, handleItemDeletePopup, handleOpenActionPopup, largeEnterpriseDetails, handleLMUSelectChange,
    handleItemTypeListTogole, handleItemTypeTogole, handleItemTogole, sectionObj, handleItemHighlight, outlineCenter, handleOpenWholeActionPopup, isWizardCompleted, show_HistoricalActions,
    gisLayerDetails, handleGISLayerDetails, gisLayerStockExclusionLandSlopeDetails, handleGISLayerStockExclusionLandSlopeDetails }) => {

    const itemList = itemModel.itemList;
    const itemTypesList = itemModel.itemTypes;
    const uniqueItemTypesList = itemModel.uniqueItemTypes;
    const Section = itemModel.Section;
    return (
        <Row>          
            <Col sm="12">
                {
                    
                    <>
                        <ItemTypeListView isWizardCompleted={isWizardCompleted} Section={Section}
                            itemTypesList={itemTypesList}
                            itemModel={itemModel}
                            toggleItemTypeListState={toggleItemTypeListState}
                            handleClearSelection={handleClearSelection}
                            handleItemClick={handleItemClick}
                            handleItemTypeListTogole={handleItemTypeListTogole}
                            gisLayerDetails={gisLayerDetails}
                            handleGISLayerDetails={handleGISLayerDetails}
                            gisLayerStockExclusionLandSlopeDetails={gisLayerStockExclusionLandSlopeDetails}
                            handleGISLayerStockExclusionLandSlopeDetails={handleGISLayerStockExclusionLandSlopeDetails}
                        >
                        </ItemTypeListView>
                        <br />
                    </>
                }

                {Section != 'Community & Cultural Significance' &&
                    <LargeFarmView largeEnterpriseDetails={largeEnterpriseDetails} handleLMUSelectChange={handleLMUSelectChange}></LargeFarmView>
                }
                {sectionObj.isWholeFarmActionRequired && !itemModel.isMapOnly &&
                    <>
                    <WholeFarmActionView outlineCenter={outlineCenter} handleOpenWholeActionPopup={handleOpenWholeActionPopup} open={false} showArrow={true}></WholeFarmActionView>
                        <br/>
                    </>
                }
                {
                    Section != "Community & Cultural Significance" && show_HistoricalActions &&
                    <>
                        <HistoricalActions sectionId={sectionObj.id} open={false} showArrow={true}></HistoricalActions>
                        <br />
                    </>
                }
                {(Section == 'WaterwaysMap' || Section == 'WaterwaysRisk') &&
                    <>
                    {uniqueItemTypesList.map(type =>
                        itemList.filter(item => item.itemTypeName == type.name).length != 0 &&
                        <WaterwayItemTypeView handleHideChildrenCheck={handleHideChildrenCheck} toggleChildItemState={toggleChildItemState} handleChildItemToggle={handleChildItemToggle} hideChildren={hideChildren} key={type.uniqueName} itemList={itemList} itemType={type} itemTypesList={itemTypesList}
                            largeEnterpriseDetails={largeEnterpriseDetails}
                            toggleItemTypeState={toggleItemTypeState}
                            toggleItemState={toggleItemState}
                            handleItemEditPopup={handleItemEditPopup}
                            handleItemDeletePopup={handleItemDeletePopup}
                            handleOpenActionPopup={handleOpenActionPopup}
                            handleItemTypeTogole={handleItemTypeTogole}
                            handleItemTogole={handleItemTogole}
                            handleItemHighlight={handleItemHighlight} Section={Section} itemModel={itemModel }
                        >
                        </WaterwayItemTypeView>
                    )}
                    </>
                }
                {Section != 'WaterwaysMap' && Section != 'WaterwaysRisk' &&
                    <>
                        {uniqueItemTypesList.map(type =>
                            itemList.filter(item => item.itemTypeName == type.name).length != 0 &&
                            <ItemTypeView key={type.uniqueName} itemList={itemList} itemType={type} itemTypesList={itemTypesList}
                                largeEnterpriseDetails={largeEnterpriseDetails}
                                toggleItemTypeState={toggleItemTypeState}
                                toggleItemState={toggleItemState}
                                handleItemEditPopup={handleItemEditPopup}
                                handleItemDeletePopup={handleItemDeletePopup}
                                handleOpenActionPopup={handleOpenActionPopup}
                                handleItemTypeTogole={handleItemTypeTogole}
                                handleItemTogole={handleItemTogole}
                                handleItemHighlight={handleItemHighlight} Section={Section} itemModel={itemModel }
                            >
                            </ItemTypeView>
                        )}
                    </>
                }

                {/*Document Upload*/}
                {
                    sectionObj.isDocumentUploadReq && Section != 'Community & Cultural Significance' && !itemModel.isMapOnly && <Documents refid={sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                }

                {/*Actions to Consider*/}
                {
                    sectionObj.isFarmAPTActionsReq && !itemModel.isMapOnly && <ActionsToConsider sectionId={sectionObj.id} />
                }
            </Col>
        </Row>
    );
}
export default NonMapView